module.exports = __webpack_public_path__ + "static/media/AnalyticsIcon.faab5136.svg";